import EmploymentComponent from '../components/employment/employment'

const Employment = () => <EmploymentComponent />

export default Employment;